import { defineComponent, getCurrentInstance, useCssModule } from '@nuxtjs/composition-api';
import { createHead, useAsyncRef } from '~/utils';
import { useDuck } from '~/services';
/**
 * Duck service.
 */
const duck = useDuck();
const OUTPUT_ARTICLES_LENGTH = 5;
export default defineComponent({
    name: 'PageEmbedNews',
    layout: 'empty',
    setup() {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Instance.
         */
        const instance = getCurrentInstance();
        /**
         * Articles.
         */
        const articles = useAsyncRef(instance, 'articles');
        return {
            articles,
            css,
        };
    },
    async asyncData(context) {
        const { app, env, error, route } = context;
        try {
            let articles = [];
            const { data: baseArticles } = await duck.pub.getPubActual();
            if (!baseArticles.length) {
                throw new Error('Not found');
            }
            if (baseArticles.length <= OUTPUT_ARTICLES_LENGTH) {
                articles = baseArticles;
            }
            else {
                // Randomize articles
                const indexes = new Set();
                do {
                    const index = Math.floor(Math.random() * baseArticles.length);
                    indexes.add(index);
                } while (indexes.size < OUTPUT_ARTICLES_LENGTH);
                for (const i of indexes) {
                    articles.push(baseArticles[i]);
                }
            }
            articles = articles.map(({ photo, photo_present: withPhoto, title, url_alias: path }) => {
                return {
                    photo,
                    title,
                    url: `${env.HOST}/${path}`,
                    withPhoto,
                };
            });
            const title = 'Актуальные новости';
            const head = {
                canonical: env.HOST + route.path,
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            return {
                $page: context.$page,
                articles,
                head,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        const head = {
            link: [],
            meta: [],
            ...createHead(this.head),
        };
        head.meta.push({ name: 'robots', content: 'noindex' });
        return head;
    },
});
